import script from "./Rule.vue?vue&type=script&lang=ts&setup=true"
export * from "./Rule.vue?vue&type=script&lang=ts&setup=true"

import "./Rule.vue?vue&type=style&index=0&id=23adb428&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-23adb428"]])

export default __exports__